import React from "react";

const sizes = {
  sm: "h-4 w-4 border-2",
  md: "h-5 w-5 border-2",
  lg: "h-7 w-7 border-[3px]",
};

export default function Spinner({ className = "", size = "sm" }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block animate-spin rounded-full border-slate-300 border-t-slate-700 ${sizes[size] || sizes.sm} ${className}`}
    />
  );
}
